// paste all font files to this folder and import them to this file

import HeldaneDisplayWebMediumEot from './HeldaneDisplayWeb-Medium.eot'
import HeldaneDisplayWebMediumWoff from './HeldaneDisplayWeb-Medium.woff'
import HeldaneDisplayWebMediumWoff2 from './HeldaneDisplayWeb-Medium.woff2'
import HeldaneDisplayWebRegularEot from './HeldaneDisplayWeb-Regular.eot'
import HeldaneDisplayWebRegularWoff from './HeldaneDisplayWeb-Regular.woff'
import HeldaneDisplayWebRegularWoff2 from './HeldaneDisplayWeb-Regular.woff2'
import HeldaneDisplayWebBoldEot from './HeldaneDisplayWeb-Bold.eot'
import HeldaneDisplayWebBoldWoff from './HeldaneDisplayWeb-Bold.woff'
import HeldaneDisplayWebBoldWoff2 from './HeldaneDisplayWeb-Bold.woff2'

import TitilliumWebBoldEot from './titilliumweb-bold-webfont.eot'
import TitilliumWebBoldWoff from './titilliumweb-bold-webfont.woff'
import TitilliumWebBoldWoff2 from './titilliumweb-bold-webfont.woff2'
import TitilliumWebRegularEot from './titilliumweb-regular-webfont.eot'
import TitilliumWebRegularWoff from './titilliumweb-regular-webfont.woff'
import TitilliumWebRegularWoff2 from './titilliumweb-regular-webfont.woff2'
import TitilliumWebLightEot from './titilliumweb-light-webfont.eot'
import TitilliumWebLightWoff from './titilliumweb-light-webfont.woff'
import TitilliumWebLightWoff2 from './titilliumweb-light-webfont.woff2'
import TitilliumWebSemiboldEot from './titilliumweb-semibold-webfont.eot'
import TitilliumWebSemiboldWoff from './titilliumweb-semibold-webfont.woff'
import TitilliumWebSemiboldWoff2 from './titilliumweb-semibold-webfont.woff2'

import HeldaneTextRegularWoff2 from './heldane-text-regular.woff2'
import HeldaneTextMediumWoff2 from './heldane-text-medium.woff2'
import HeldaneTextBoldWoff2 from './heldane-text-bold.woff2'

import PortraitBoldTrial from './portrait/Portrait-Bold-Web.woff2'
import PortraitMediumTrial from './portrait/Portrait-Medium-Web.woff2'
import PortraitLightTrial from './portrait/Portrait-Light-Web.woff2'
import PortraitRegularTrial from './portrait/Portrait-Regular-Web.woff2'
import PortraitRegular2Trial from './portrait/Portrait-Regular2-Web.woff2'

import TestSohneLight from './sohne/soehne-leicht.woff2';
import TestSohneRegular from './sohne/soehne-buch.woff2';
import TestSohneSemiBold from './sohne/soehne-halbfett.woff2';
import TestSohneBold from './sohne/soehne-dreiviertelfett.woff2';

// highlight font
import ArialBoldMT from './Arial-BoldMT.woff2'


export default {

   // highlight font
   ArialBoldMT,

   // Portait fonts
   PortraitBoldTrial,
   PortraitMediumTrial,
   PortraitLightTrial,
   PortraitRegularTrial,
   PortraitRegular2Trial,

   // TestSohne fonts
   TestSohneLight,
   TestSohneRegular,
   TestSohneSemiBold,
   TestSohneBold,

   // all imported fonts
   HeldaneDisplayWebMediumEot,
   HeldaneDisplayWebMediumWoff,
   HeldaneDisplayWebMediumWoff2,
   HeldaneDisplayWebBoldEot,
   HeldaneDisplayWebBoldWoff,
   HeldaneDisplayWebBoldWoff2,
   HeldaneDisplayWebRegularEot,
   HeldaneDisplayWebRegularWoff,
   HeldaneDisplayWebRegularWoff2,
   TitilliumWebBoldEot,
   TitilliumWebBoldWoff,
   TitilliumWebBoldWoff2,
   TitilliumWebRegularEot,
   TitilliumWebRegularWoff,
   TitilliumWebRegularWoff2,
   TitilliumWebLightEot,
   TitilliumWebLightWoff,
   TitilliumWebLightWoff2,
   TitilliumWebSemiboldEot,
   TitilliumWebSemiboldWoff,
   TitilliumWebSemiboldWoff2,
   HeldaneTextRegularWoff2,
   HeldaneTextMediumWoff2,
   HeldaneTextBoldWoff2,
}
